import React from "react";
import { Grid } from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { TextField, InputAdornment } from "@mui/material";

const SearchBar = ({ placeholder, handleSearch }) => {
  return (
    <Grid container alignItems={"center"} justifyContent={"space-between"}>
      <TextField
        variant="outlined"
        placeholder={placeholder || "Search"}
        onChange={(e) => handleSearch && handleSearch(e)}
        InputProps={{
          sx: { ...searchTextfieldStyles },
          startAdornment: (
            <InputAdornment position="start">
              <SearchOutlinedIcon />
            </InputAdornment>
          ),
        }}
      />
    </Grid>
  );
};

export default SearchBar;

const searchTextfieldStyles = {
  height: 40,
  border: "none",
  borderColor: "#7676801F",
  borderRadius: 5,
  width: 320,
  background: "#7676801F",
  color: "#515563",
  fontSize: 14,
  fontWeight: 500,
  paddingLeft: 1,
  paddingRight: 2,
  fontFamily: "Avenir Book, sans-serif",
};
